<template>
  <div class="card">
    <div v-if="hasHits" class="card-body" v-html="body" />

    <a href="#" v-if="isCollapsible" @click.prevent="isCollapsed = !isCollapsed" class="pb-4 pl-4">Show {{ isCollapsed ? 'more' : 'less' }}</a>

    <div :class="hasHits ? 'card-footer' : 'card-body'" class="d-flex align-items-center justify-content-between">
      <span>
        <i class="fa fa-link t-secondary mr-2" /><a :href="result.data.url" target="_blank">{{ result.data.url.split('?')[0] }}</a>
      </span>
      <bookmark-folder
        v-if="$currentUser"
        :currentItem="result.data"
        :scope="index"
        isFromSearch
        attachedToBody
        isButton>
      </bookmark-folder>
    </div>
  </div>
</template>

<script>
import BookmarkFolder from '@/components/bookmark_folder/Show'

export default {
  name: 'websiteMatches',
  components: {
    BookmarkFolder
  },
  props: {
    index: {
      type: String,
      required: true
    },
    result: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isCollapsed: true
    }
  },
  computed: {
    isCollapsible () {
      if (this.result.highlights.body && this.result.highlights.body.length > 3) return true
      return false
    },
    body () {
      if (this.result.highlights.body) {
        const resultsToShow = this.isCollapsed ? this.result.highlights.body.slice(0, 3) : this.result.highlights.body
        return `<div>${resultsToShow.join('<hr /></div><div>')}</div>`
      }

      return `<div class="t-overflow">${this.result.data.body}</div>`
    },
    hasHits () {
      return Boolean(this.result.hit_type)
    }
  }
}
</script>
